export const handleUpdateView = async ({ context } = {}) => {
  if (!context || typeof context.refreshSchema !== 'function') {
    return;
  }

  context.refreshSchema();
};
